import type { ComponentPropsWithoutRef, ElementType } from 'react';
import { heading, level } from './Heading.css';

type HeadingLevel = keyof typeof level;

const defaultElementByLevel: Record<HeadingLevel, ElementType> = {
  display: 'h1',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
};

export type HeadingProps = ComponentPropsWithoutRef<'h1'> & {
  level?: HeadingLevel;
  as?: ElementType;
};

export function Heading({ level: l = 'h2', as, className, ...rest }: HeadingProps) {
  const Element = as ?? defaultElementByLevel[l];
  const classes = [heading, level[l], className].filter(Boolean).join(' ');
  return <Element className={classes} {...rest} />;
}
